import React, { useEffect, useRef } from "react";
import { isObserver } from "../../p5/sketch";
import Loader from "../loader";
import P5Background from "../p5Background";
import ScrollIndicator from "../scrollIndicator";
import "./_homeBanner.scss";

const observer = new IntersectionObserver((entries) => {
  entries.forEach((entry) => {
    if (entry.isIntersecting) {
      isObserver(true);
    } else {
      isObserver(false);
    }
  });
});

function HomeBanner({ loading }) {
  const background = useRef();

  useEffect(() => {
    observer.observe(background.current);
  });

  return (
    <section className="home" ref={background}>
      <P5Background />
      <header className="header">
        {loading ? (
          <Loader />
        ) : (
          <>
            <div className="header-content container">
              <h1 className="text-gradient focus-in-expand">
                Guillermo Zevallos
              </h1>
              <h2 className="focus-in-expand">Frontend Developer</h2>
            </div>
            <ScrollIndicator />
          </>
        )}
      </header>
    </section>
  );
}

export default HomeBanner;
